const isFeatureAccessible = (
  featureId: string,
  accessibleFeatures: string[]
): boolean => {
  const isAccessible = accessibleFeatures.includes(featureId);
  return isAccessible;
};

const DEFAULT_TEMPLATES_ADMIN_BASE_EMAILS = [
  "andrew@caseblink.com",
  "yasmine@caseblink.com",
  "tina@caseblink.com",
  "roxanne@caseblink.com",
  "joseph@caseblink.com",
  "khalil@caseblink.com",
  "moussa@caseblink.com"
];

const getBaseEmail = (email: string | undefined): string | null => {
  if (!email) return null;

  const normalizedEmail = email.toLowerCase();
  const [localPart, domain] = normalizedEmail.split("@");
  if (!localPart || !domain) return null;

  const baseLocalPart = localPart.split("+")[0];
  return `${baseLocalPart}@${domain}`;
};

const isDefaultTemplatesAdmin = (email: string | undefined): boolean => {
  const baseEmail = getBaseEmail(email);
  if (!baseEmail) return false;

  return DEFAULT_TEMPLATES_ADMIN_BASE_EMAILS.includes(baseEmail);
};

export { isFeatureAccessible, isDefaultTemplatesAdmin };
